/**
 * Top bar (plan 6.B). Left: draft/editing label. Right: saved state · Preview · Create/Save event.
 */

import React from "react";
import Icon from "../ui/Icon";
import { useBuilder } from "../state/builderContext";
import { actions } from "../state/builderReducer";
import { COPY } from "../state/constants";
import { draftLabel, savedStateClass, savedStateText, topCreateLabel } from "../state/selectors";

const BuilderTopbar = ({ onPublish, publishing }) => {
  const { state, dispatch, retry, issues, ready } = useBuilder();
  const status = state.save.status;
  const text = savedStateText(state);
  const cls = savedStateClass(state);
  const disabled = !ready || publishing || status === "saving" || issues.length > 0 || state.meta.loading || Boolean(state.meta.loadError);

  return (
    <header className="eb-builder-topbar">
      <div className="eb-builder-topbar-left">
        <span className="eb-draft-label">{draftLabel(state)}</span>
      </div>
      <div className="eb-builder-actions">
        <span className={`eb-saved-state ${cls}`.trim()} aria-live="polite">
          <i />
          {status === "error" ? (
            <button type="button" onClick={retry} title={state.save.lastError || ""}>
              {text}
            </button>
          ) : (
            text
          )}
        </span>
        <button
          type="button"
          className="eb-ghost-btn"
          onClick={() => dispatch(actions.ui({ previewOpen: true }))}
          disabled={state.meta.loading}
        >
          <Icon name="eye" size={17} />
          {COPY.topbar.preview}
        </button>
        <button type="button" className="eb-top-create" onClick={onPublish} disabled={disabled}>
          {topCreateLabel(state)}
        </button>
      </div>
    </header>
  );
};

export default BuilderTopbar;
